import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function OrderConfirmation() {
  const navigate = useNavigate();
  return (
    <div style={{ padding: '80px 20px', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <p style={{ fontSize: '64px', margin: '0 0 16px' }}>✅</p>
      <h2>Order Confirmed!</h2>
      <p style={{ color: '#555', maxWidth: '480px', margin: '12px auto' }}>
        Thank you for your order. You'll receive a confirmation email shortly.
        If you provided a wallet address, your NFT certificate of authenticity
        will be sent to your wallet once your order is processed.
      </p>
      <button onClick={() => navigate('/')}
        style={{ marginTop: '24px', padding: '12px 32px', background: '#111',
          color: '#fff', border: 'none', borderRadius: '8px',
          fontSize: '16px', cursor: 'pointer' }}>
        Continue Shopping
      </button>
    </div>
  );
}
